import { ProductData } from "../../../types/ProductService/ProductService";
import { translate } from "../../Translations/translatorService";
import { persistGeneralCivilLaw } from "../../Persist/GeneralCivilLawPersister";
import * as generalCivilLawStages from "../../Stages/StagesGeneralCivilLaw";
import { stageMetaDataGeneralCivilLaw } from "../../Stages/StagesGeneralCivilLaw";
import * as caseStatus from "../../LeadStatus/StatusCase";
import * as caseStages from "../../Stages/StagesCase";
import generalCivilLawTransformations from "../FormTransformations/generalCivilLawTransformations";
import { stageFormDefinition as stageFormDefinitionGeneralCivilLaw } from "../FormDefinitions/generalCivilLaw/stageFormDefinition";
import { fullFormDefinition as fullFormDefinitionGeneralCivilLaw } from "../FormDefinitions/generalCivilLaw/fullFormDefinition";
import { getLitigationCaseBadges } from "../Badges/getLitigationCaseBadges";
import { litigationCaseSubBarAdditionalInformation } from "../CaseSubBarAdditionalInformation/litigationCaseSubBarAdditionalInformation";
import { inquiryTypeAvailability } from "../../inquiryService";
import {
  litigationCaseCourtAppointmentCreationAvailable,
  placeholderPaymentTypeSwitchData,
} from "./productServiceFunctions";
import { getProductData } from "./productService";
import { generalCivilLawDetailsSpecialActions } from "../CaseDetailsSpecialActions/generalCivilLawDetailsSpecialActions";
import { GeneralCivilLaw } from "../../../types/Products/GeneralCivilLaw";

export const generalCivilLaw: ProductData<GeneralCivilLaw> = {
  urlPart: "allgemeines-zivilrecht",
  lbUrlPart: "allgemeines-zivilrecht",
  label: translate("generalCivilLaw.label"),
  generalLabel: translate("generalCivilLaw.label"),
  apiUri: "general_civil_laws",
  persist: persistGeneralCivilLaw,
  stages: stageMetaDataGeneralCivilLaw,
  stageConstants: generalCivilLawStages,
  minimumCaseStatus: caseStatus.STATUS_CREATED,
  minimumCaseStage: caseStages.STAGE_CREATED,
  setBackCaseStage: caseStages.STAGE_DATA_COMPLETED,
  paymentType: {
    insurance: "RSV",
  },
  paymentTypeSwitchData: placeholderPaymentTypeSwitchData,
  courtAppointmentCreationAvailable: litigationCaseCourtAppointmentCreationAvailable,
  lbProductClass: "App\\Entity\\Legalbird\\CivilLaw\\GeneralCivilLaw\\GeneralCivilLaw",
  formTransformations: generalCivilLawTransformations,
  formDefinition: ({ product, currentUser }) => stageFormDefinitionGeneralCivilLaw(product, currentUser),
  formDefinitionExternals: ({ product }) => stageFormDefinitionGeneralCivilLaw(product)[product.stage],
  fullFormDefinition: ({ product, currentUser }) => fullFormDefinitionGeneralCivilLaw(product, currentUser),
  caseDetailsSpecialActions: ({ product }) => generalCivilLawDetailsSpecialActions(product),
  productCategory: "civilLaw",
  productSpecificBadges: ({ product }) => getLitigationCaseBadges(product),
  caseSubBarAdditionalInformation: ({ product, currentUser }) =>
    litigationCaseSubBarAdditionalInformation(product, currentUser),
  showCaseDescription: ({ product }) => {
    return product.stage >= getProductData(product.productClassName, "setBackCaseStage");
  },
  inquiryTypeAvailability: inquiryTypeAvailability.generalCivilLaw,
};
